import {
    FC,
    ReactElement,
    useEffect,
} from 'react'
import { useNavigate, useParams } from 'react-router'

import {
    Button,
    Card,
    InfoListBlock,
    InfoListItem,
    LoadingSpinner,
} from '@/components'
import { formatDate } from '@/helpers/date'
import { convertDateToTime } from '@/helpers/DateTimeParser'
import { trans } from '@/helpers/trans'
import { deletePlanningPreference, getPlanningPreference } from '@/redux/preferences/preferenceActions'
import { useTypedDispatch, useTypedSelector } from '@/redux/store'

import './PlanningPreferenceDetailPage.scss'

export const PlanningPreferenceDetailPage: FC = (): ReactElement | null => {
    const dispatch = useTypedDispatch()
    const navigate = useNavigate()
    const { planningPreferenceId } = useParams()
    const { planningPreference, loading } = useTypedSelector(state => state.preferenceReducer)

    useEffect(() => {
        if (planningPreferenceId) {
            dispatch(getPlanningPreference(planningPreferenceId))
        }
    }, [])

    if (! planningPreference) {
        return null
    }

    const handleDeleteClick = (): void => {
        dispatch(deletePlanningPreference(planningPreference.id, navigate))
    }

    const readableDate = formatDate(new Date(planningPreference.start))
    const time = `${convertDateToTime(planningPreference.start)} - ${convertDateToTime(planningPreference.end)}`

    return (
        <>
            <Card className="planning-preference-detail__header">
                {trans('pages.planningPreferences.planningPreference')}
            </Card>
            <ul className="mb-4">
                <InfoListItem label={trans('common.date')}>
                    {readableDate}
                </InfoListItem>
                <InfoListItem label={trans('common.time')}>
                    {time}
                </InfoListItem>
                <InfoListBlock label={trans('common.reason')}>
                    <textarea
                        className="form-control border-0"
                        disabled
                        value={planningPreference.comment || ''}
                        placeholder={trans('common.description')}
                    />
                </InfoListBlock>
            </ul>
            <Button
                text={trans('common.delete')}
                onClick={handleDeleteClick}
                className="planning-preference-detail__delete-button"
            />
            {loading && <LoadingSpinner />}
        </>
    )
}
